import * as React from 'react';
import type { SearchBoxContainerHandle } from 'owa-search/lib/types/SearchBoxContainerHandle';
import { SearchBoxAsync } from '../../../searchbox';
import type { Store } from 'redux';
import { getAppState } from '../../../appstate';

export default function getPeopleHeaderProps(store: Store) {
    return (searchBoxRef: React.RefObject<SearchBoxContainerHandle>) => ({
        props: {
            centeredSearchBox: false,
            renderSearch: () => <SearchBoxAsync store={store} searchBoxRef={searchBoxRef} />,
            enableResponsiveLayout: true,
            searchAlignmentWidth: getAppState(store.getState()).view.layoutState.leftPaneWidth,
        },
    });
}
